import React, { useState } from 'react';
import { Paper, Tabs } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import PhysicalExaminationSection from './PhysicalExamination/PhysicalExaminationSection';
import MedicalHistorySection from './MedicalHistory/MedicalHistorySection';
import CounsellingNoteSection from './CounsellingNote/CounsellingNoteSection';
import classes from './ClinicalNotesPanel.module.css';

interface ClinicalNotesPanelProps {
    patientId?: string | number;
    patientName?: string | null;
    patientDateOfBirth?: string | null;
}

const PANEL_STYLE = { borderRadius: '0 10px 10px 10px' } as const;

const ClinicalNotesPanel: React.FC<ClinicalNotesPanelProps> = ({
    patientId,
    patientName,
    patientDateOfBirth,
}) => {
    const { t } = useTranslation();
    const location = useLocation();
    const initialTab =
        (location.state as { clinicalNotesTab?: string } | null)
            ?.clinicalNotesTab ?? 'physicalExam';
    const [activeTab, setActiveTab] = useState<string>(initialTab);

    return (
        <Tabs
            value={activeTab}
            onChange={(v) => v && setActiveTab(v)}
            keepMounted={false}
            classNames={classes}
        >
            <Tabs.List>
                <Tabs.Tab value="physicalExam">
                    {t('clinicalNotes.tabs.physicalExam')}
                </Tabs.Tab>
                <Tabs.Tab value="medicalHistory">
                    {t('clinicalNotes.tabs.medicalHistory')}
                </Tabs.Tab>
                <Tabs.Tab value="counselling">
                    {t('clinicalNotes.tabs.counselling')}
                </Tabs.Tab>
            </Tabs.List>

            <Tabs.Panel value="physicalExam">
                <Paper p="md" shadow="xs" withBorder style={PANEL_STYLE}>
                    <PhysicalExaminationSection
                        patientId={patientId}
                        patientName={patientName}
                        patientDateOfBirth={patientDateOfBirth}
                    />
                </Paper>
            </Tabs.Panel>

            <Tabs.Panel value="medicalHistory">
                <Paper p="md" shadow="xs" withBorder style={PANEL_STYLE}>
                    <MedicalHistorySection
                        patientId={patientId}
                        patientName={patientName}
                        patientDateOfBirth={patientDateOfBirth}
                    />
                </Paper>
            </Tabs.Panel>

            <Tabs.Panel value="counselling">
                <Paper p="md" shadow="xs" withBorder style={PANEL_STYLE}>
                    <CounsellingNoteSection
                        patientId={patientId}
                        patientName={patientName}
                        patientDateOfBirth={patientDateOfBirth}
                    />
                </Paper>
            </Tabs.Panel>
        </Tabs>
    );
};

export default ClinicalNotesPanel;
